import React, { Component } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  Slide,
  withStyles,
} from 'material-ui';
import DialogStyles from './TermsDialogStyles';
import TermsDialogProps from './TermsDialogProps';
import MainController from '../../../controllers/MainController';
import Dictionary from '../../../model/Dictionary';
import Checkbox from '../../checkbox/Checkbox';

/**
 * ## Redux imports
 */
import * as globalActions from '../../../redux/actions/GlobalActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../../redux/selectors/Index';

function Transition (props) {
  return <Slide direction='up' {...props} />;
}

class TermsDialog extends Component {
  static propTypes = TermsDialogProps;
  state = { acceptTerms: false, showError: false };

  acceptTerms = () => {
    this.setState({ acceptTerms: !this.state.acceptTerms, showError: false });
  };

  onClick = () => {
    const { acceptTerms } = this.state;
    if (!acceptTerms) {
      this.setState({ showError: true });
    } else {
      this.props.onAcceptTerms();
      this.props.handleClose();
    }
  };

  render () {
    const { termsOpened, handleClose, terms, classes } = this.props;
    const { acceptTerms, showError } = this.state;
    return (
      <div>
        <Dialog
          fullScreen={MainController.showMobileVersion()}
          open={termsOpened}
          onClose={handleClose}
          transition={Transition}
          classes={classes}
        >
          <DialogTitle id='alert-dialog-slide-title'>
            {terms && terms.title ? terms.title : Dictionary.terms.title}
          </DialogTitle>
          <DialogContent>
            {terms && terms.note ? (
              <DialogContentText style={{ color: 'brown' }}>{terms.note}</DialogContentText>
            ) : null}
            {/* {terms && terms.description && terms.description.length ?
              terms.description.map((term, index) => ( */}
            <DialogContentText style={{ marginTop: 10 }}>{terms.description}</DialogContentText>
            {/* )) : null} */}
            <Checkbox
              label={Dictionary.terms.checkbox}
              value={acceptTerms}
              name='terms'
              onChange={() => this.acceptTerms}
            />
            {!showError ? null : (
              <DialogContentText style={{ color: 'red' }}>
                {Dictionary.terms.error}
              </DialogContentText>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onClick} variant='raised' color='primary' disabled={showError}>
              {Dictionary.terms.accept}
            </Button>
            <Button onClick={handleClose} color='default'>
              {Dictionary.terms.cancel}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

/**
 * ## Redux boilerplate
 */
const actions = [ globalActions ];

function mapStateToProps (state) {
  return {
    isFetching: selectors.global.isFetching(state.global),
    terms: selectors.terms.getTerms(state.terms),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(DialogStyles)(TermsDialog));



// WEBPACK FOOTER //
// ./src/components/review/termsAndConditions/TermsDialog.js